/**
 * PDF出力用ユーティリティ関数
 * state に依存しない純粋関数群
 */
import { toJpeg, toPng } from 'html-to-image';
import html2canvas from 'html2canvas';

/** 製品画像のスケール計算 */
export const scaleImage = (img: HTMLImageElement, width: number, height: number) => {
  const aspectRatio = img.width / img.height;
  let scaledWidth, scaledHeight;

  if (aspectRatio > 1) {
    scaledWidth = width;
    scaledHeight = width / aspectRatio;
  } else {
    scaledHeight = height;
    scaledWidth = height * aspectRatio;
  }

  const xOffset = (width - scaledWidth) / 2;
  const yOffset = (height - scaledHeight) / 2;

  return { scaledWidth, scaledHeight, xOffset, yOffset };
};

/** elementをPNG画像に変換する関数 */
export const convertHtmlToImagePng = async (element: HTMLElement, ratio: number) => {
  try {
    const dataUrl = await toPng(element, {
      width: element.scrollWidth,
      canvasWidth: element.scrollWidth,
      height: element.scrollHeight,
      canvasHeight: element.scrollHeight,
      backgroundColor: '#FFFFFF',
      pixelRatio: ratio,
    });
    return dataUrl;
  } catch (error) {
    console.error('Error converting HTML to image:', error);
    return null;
  }
};

/** elementをSVGベースのJPEG画像に変換する関数 */
export const convertHtmlToImageJpeg = async (element: HTMLElement, ratio: number, scrollWidth?: number) => {
  try {
    const width = scrollWidth ? scrollWidth : element.scrollWidth;
    const dataUrl = await toJpeg(element, {
      width: width,
      canvasWidth: width,
      height: element.scrollHeight,
      canvasHeight: element.scrollHeight,
      backgroundColor: '#FFFFFF',
      pixelRatio: ratio,
      quality: 0.8,
    });
    return dataUrl;
  } catch (error) {
    console.error('Error converting HTML to image:', error);
    return null;
  }
};

/** elementをCanvasベースのJPEG画像に変換する関数 */
export const convertHtmlToImageJpegUsingHtml2Canvas = async (element: HTMLElement, ratio: number, fixedWidth?: number) => {
  try {
    const canvas = await html2canvas(element, {
      scale: ratio,
      backgroundColor: "#FFFFFF",
      ...(fixedWidth ? { windowWidth: fixedWidth } : {}),
    });
    return canvas.toDataURL("image/jpeg", 0.8);
  } catch (error) {
    console.error("Error converting HTML to image using html2canvas:", error);
    return null;
  }
};

/** レイアウト計算（ページに収まるスケール） */
export const calculateScaleToFitPage = (originalWidth: number, originalHeight: number, pageWidth: number, pageHeight: number): number => {
  const widthRatio = pageWidth / originalWidth;
  const heightRatio = pageHeight / originalHeight;
  return Math.min(widthRatio, heightRatio);
};
